(() => {
  let works = [];
  try { works = JSON.parse(document.querySelector('#roscoff-works-index')?.textContent || '[]'); } catch {}
  const normalize = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('fr').replace(/[’']/g, ' ');
  const matches = (item, terms) => terms.every(term => normalize(item.title).split(/\s+/).some(word => word.startsWith(term)));
  const previewUrl = url => {
    const preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (!preview) return url;
    const target = new URL(url, location.origin);
    target.searchParams.set('preview_theme_id', preview);
    return target.pathname + target.search + target.hash;
  };
  document.querySelectorAll('[data-predictive-search]').forEach(root => {
    const form = root.querySelector('form'), input = root.querySelector('[name="q"]');
    const results = root.querySelector('[data-predictive-results]'), status = root.querySelector('[data-predictive-status]');
    let timer, controller, sequence = 0, active = -1, nativeNodes = [];
    const options = () => [...results.querySelectorAll('[role="option"]')];
    const close = () => { results.hidden = true; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); active = -1; };
    const cancel = () => { clearTimeout(timer); controller?.abort(); sequence++; };
    const localMatches = (limit = 8) => {
      const query = normalize(input.value.trim()).split(/\s+/).filter(Boolean);
      if (!query.length) return [];
      return [
        ...works.filter(item => matches(item, query)).map(item => ({...item, type: 'shop'}))
      ].slice(0, limit);
    };
    const renderFullResults = () => {
      const grid = document.querySelector('[data-local-search-results]');
      if (!grid) return;
      const native = [...document.querySelectorAll('.roscoff-search-results:not([data-local-search-results]) .work-meta h2')]
        .map(el => normalize(el.textContent.trim()));
      const items = localMatches(Infinity).filter(item => !native.includes(normalize(item.title)));
      grid.replaceChildren();
      items.forEach(item => {
        const card = document.createElement('article');card.className = 'work-card';
        const imageLink = document.createElement('a');imageLink.className = 'work-image';imageLink.href = previewUrl(item.url);
        const image = document.createElement('img');image.src = item.image;image.alt = item.title;image.loading = 'lazy';
        imageLink.append(image);
        const meta = document.createElement('div');meta.className = 'work-meta';
        const title = document.createElement('h2');title.textContent = item.title;
        const link = document.createElement('a');link.href = imageLink.href;link.textContent = root.dataset.shopLabel;
        meta.append(title, link);card.append(imageLink, meta);grid.append(card);
      });
      grid.hidden = !items.length;
      const empty = document.querySelector('.roscoff-search-results:not([data-local-search-results]) .roscoff-search-empty');
      if (empty && items.length) empty.hidden = true;
    };
    const render = () => {
      const list = document.createElement('ul');
      list.id = 'roscoff-suggestions'; list.setAttribute('role', 'listbox'); list.setAttribute('aria-label', root.dataset.suggestionsLabel);
      const local = localMatches();
      local.forEach(item => {
        const row = document.createElement('li');
        row.id = 'suggest-' + item.type + '-' + item.reference.replace(/[^a-z0-9]/gi, '-');
        row.setAttribute('role', 'option');row.setAttribute('aria-selected', 'false');
        const link = document.createElement('a');link.href = previewUrl(item.url);link.tabIndex = -1;
        const image = document.createElement('img');image.src = item.image;image.alt = '';image.width = 90;image.height = 65;image.loading = 'lazy';
        const text = document.createElement('span'), title = document.createElement('strong'), category = document.createElement('small');
        title.textContent = item.title;category.textContent = root.dataset.shopLabel;
        text.append(title, category);link.append(image, text);row.append(link);list.append(row);
      });
      const localTitles = new Set(local.map(item => normalize(item.title)));
      nativeNodes.filter(node => !localTitles.has(normalize(node.querySelector('strong')?.textContent || ''))).slice(0, Math.max(0, 8 - list.children.length)).forEach(node => list.append(node.cloneNode(true)));
      const button = document.createElement('button');button.type='button';button.className='text-link';button.dataset.predictiveClose='';button.textContent=root.dataset.close;
      results.replaceChildren(list, button);active = -1;input.removeAttribute('aria-activedescendant');
      const count = list.children.length;results.hidden=!count;input.setAttribute('aria-expanded',String(!!count));status.textContent=count?`${count} ${root.dataset.count}${count === 1 ? '' : 's'}`:'';
    };
    const search = async () => {
      const query=input.value.trim();if(!query){close();status.textContent='';return;}
      const token=++sequence;controller=new AbortController();
      try {
        const url=new URL(root.dataset.endpoint,location.origin);url.searchParams.set('q',query);url.searchParams.set('resources[type]','product');url.searchParams.set('resources[limit]','5');url.searchParams.set('resources[options][fields]','title');url.searchParams.set('section_id','roscoff-predictive');
        const preview=new URLSearchParams(location.search).get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);
        const response=await fetch(url,{signal:controller.signal});if(!response.ok)throw new Error('Predictive search unavailable');
        const html=new DOMParser().parseFromString(await response.text(),'text/html');
        if(token!==sequence||input.value.trim()!==query)return;
        const content=html.querySelector('[data-predictive-content]');if(!content)throw new Error('Predictive section unavailable');
        nativeNodes=[...content.querySelectorAll('[role="option"]')];render();
      } catch(error) {if(error.name!=='AbortError'&&token===sequence){nativeNodes=[];render();if(!options().length)status.textContent=root.dataset.error;}}
    };
    const onInput=event=>{cancel();nativeNodes=[];render();if(!event?.isComposing&&input.value.trim())timer=setTimeout(search,160);};
    input.addEventListener('input',onInput);input.addEventListener('compositionend',onInput);
    input.addEventListener('keydown',event=>{
      if(event.key==='Escape'){cancel();close();status.textContent='';return;}
      if(results.hidden)return;const items=options();
      if(event.key==='ArrowDown'||event.key==='ArrowUp'){event.preventDefault();active=(active+(event.key==='ArrowDown'?1:-1)+items.length)%items.length;items.forEach((item,i)=>item.setAttribute('aria-selected',String(i===active)));input.setAttribute('aria-activedescendant',items[active].id);}
      else if(event.key==='Enter'&&active>=0){event.preventDefault();items[active].querySelector('a').click();}
    });
    results.addEventListener('click',event=>{if(event.target.closest('[data-predictive-close]')){cancel();close();input.focus();}});
    document.addEventListener('click',event=>{if(!root.contains(event.target)){cancel();close();}});
    root.addEventListener('focusout',()=>{setTimeout(()=>{if(!root.contains(document.activeElement)){cancel();close();}},0);});
    form.addEventListener('submit',()=>{cancel();close();});
    if(input.value.trim()){onInput();renderFullResults();}
  });
})();
